import { Texture } from "../../../texture";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";

export type ImageRectComponentState = {
  texture: Texture;
};

export class ImageRectComponent extends Webgl2Component<undefined, ImageRectComponentState> {
  constructor(texture: Texture) {
    super({ texture });
    this.transform.setSize(texture.textureSize);
  }

  public getRenderData() {
    const material = Webgl2.materials.default;
    material.setTexture("u_texture0", this.state.texture);
    return { material };
  }
}

export default ImageRectComponent;
